module.exports = __webpack_public_path__ + "static/media/10.ceaa4799.jpg";